import { makeStyles } from "@material-ui/core/styles";
const useBuyoutStyles = makeStyles(theme => ({
    headerTitle: {
        fontWeight: 700,
        fontSize: 46,
        marginBottom: 8,
        "@media (max-width: 600px)": {
            fontSize: 36,
            textAlign: "left"
        }
    },
    // Search / header controls
    searchBox: {
        display: "flex",
        gap: 16,
        "@media (max-width: 600px)": {
            gap: 8
        }
    },
    searchTextBox: {
        "@media (max-width: 600px)": {
            order: 1,
            flex: 3
        }
    },
    searchAutocompleteBox: {
        "@media (max-width: 600px)": {
            order: 2,
            flex: 2
        }
    },
    container: {
        display: "flex",
        flexDirection: "column",
        margin: 32
    },
    contractRow: {
        display: "flex",
        flexDirection: "row",
        gap: 32,
        marginTop: 32,
        "@media (max-width: 600px)": {
            flexDirection: "column",
            width: "100%",
            gap: 24
        }
    },
    card: {
        background: "#FDF8F1",
        borderRadius: 16,
        padding: 24,
        display: "flex",
        flexDirection: "column",
        minWidth: 400,
        gap: 12,
        "@media (max-width: 600px)": {
            minWidth: "unset",
            maxWidth: "unset",
            width: "100%"
        },
        flex: 1
    },
    customerCard: {
        background: "#EBDDFF",
        minWidth: 260,
        maxWidth: 300,
        gap: 24,
        height: "fit-content",
        flex: "unset",
        "@media (max-width: 600px)": {
            minWidth: "unset",
            maxWidth: "unset",
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr"
        }
    },
    exportBox: {
        display: "flex",
        justifyContent: "flex-end"
    },
    tableBody: {
        background: "#FFFFFF"
    },
    desktopDetails: {
        "@media (max-width: 600px)": {
            display: "none"
        }
    },
    mobileDetails: {
        display: "none",
        "@media (max-width: 600px)": {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 24
        }
    },
    section: {
        marginBottom: 16
    },
    paymentInfoContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginRight: 32,
        "@media (max-width: 600px)": {
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginRight: 0,
            gap: 24
        }
    },
    paymentInfo: {
        display: "flex",
        flexDirection: "column"
    },
    link: {
        color: "#8734FF",
        cursor: "pointer",
        textDecoration: "underline",
        whiteSpace: "nowrap",
        fontSize: 14
    },
    mediumLink: {
        fontSize: 16
    },
    title: {
        fontWeight: 700,
        fontSize: 46,
        marginBottom: 8
    },
    priceTypeTitle: {
        fontWeight: 600,
        fontSize: 16
    },
    infoText: {
        fontWeight: 400,
        fontSize: 16,
        color: "#404060",
        flex: 1
    },
    infoTextBottom: {
        marginTop: 32,
        marginLeft: 32,
        marginRight: 32,
        textAlign: "center",
        "@media (max-width: 600px)": {
            marginLeft: 0,
            marginRight: 0
        }
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: 18,
        marginBottom: 8
    },
    sectionTitleunderline: {
        textDecoration: "underline",
        textDecorationColor: "#75FF8E",
        textUnderlineOffset: "7px",
        textDecorationThickness: "2px",
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontWeight: 500
    },
    sectionTitleSubtitle: {
        fontSize: 16
    },
    emailSubtitle: {
        fontWeight: 600,
        fontSize: 18,
        marginBottom: 2
    },
    emailInput: {
        width: "100%",
        "& .MuiOutlinedInput-root, & .input, & input": {
            backgroundColor: "#FFFFFF",
            borderRadius: 16
        },
        "& input": {
            padding: "16px 14px"
        }
    },
    emailForm: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        width: "80%",
        marginBottom: "33%",
        "@media (max-width: 600px)": {
            width: "100%"
        }
    },
    emailConfirmation: {
        alignItems: "center",
        textAlign: "center"
    },
    slideinContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%"
    },
    slideinTitle: {
        fontWeight: 700,
        fontSize: 30,
        marginBottom: "8vh",
        marginTop: "2vh"
    },
    slideinOverlay: {
        position: "fixed",
        top: 0,
        right: 0,
        height: "100vh",
        width: "50vw",
        background: "#F4F2F9",
        zIndex: 1301,
        display: "flex",
        flexDirection: "column",
        padding: "32px 48px",
        transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: "translateX(100%)",
        "@media (max-width: 600px)": {
            width: "100vw"
        }
    },
    slideinOverlayOpen: {
        transform: "translateX(0)"
    },
    backdrop: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",
        zIndex: 1300,
        transition: "opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        opacity: 1
    },
    backdropHidden: {
        opacity: 0,
        pointerEvents: "none"
    },
    closeButton: {
        background: "none",
        border: "none",
        fontSize: 16,
        fontWeight: 400,
        cursor: "pointer",
        display: "none",
        "@media (max-width: 600px)": {
            display: "flex"
        }
    },
    closeButtonDesktop: {
        position: "absolute",
        top: 24,
        right: 32,
        display: "unset",
        "@media (max-width: 600px)": {
            display: "none"
        }
    },
    priceBox: {
        border: "1px solid #8734FF",
        padding: "12px 24px",
        fontWeight: 400,
        fontSize: 18,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        "@media (max-width: 600px)": {
            fontSize: 16
        }
    },
    priceBoxSelected: {
        borderColor: "#8734FF",
        background: "#EBDDFF",
        textDecoration: "underline"
    },
    priceBoxDisabled: {
        border: "1px solid #ccc",
        background: "#f5f5f5",
        color: "#aaa",
        cursor: "not-allowed",
        textDecoration: "none"
    },
    rightSection: {
        display: "flex",
        flexDirection: "column",
        gap: 24,
        height: "fit-content",
        "@media (max-width: 600px)": {
            "& > *:first-child": {
                order: 2
            },
            "& > *:last-child": {
                order: 1
            }
        }
    },
    buyoutTextAndButton: {
        display: "flex",
        alignItems: "center",
        marginBottom: 24,
        "@media (max-width: 600px)": {
            flexDirection: "column",
            alignItems: "center",
            gap: 12
        }
    },
    icon: {
        width: 40,
        height: 40,
        margin: 16,
        "@media (max-width: 600px)": {
            display: "none"
        }
    },
    iconOfferLetter: {
        width: 80,
        height: 80,
        margin: 0,
        "@media (max-width: 600px)": {
            display: "block"
        }
    },
    breadcrumbs: {
        fontSize: 12,
        marginBottom: 16
    },
    breadcrumb: {
        fontSize: 12,
        color: "#000",
        textDecoration: "none",
        fontWeight: 400,
        cursor: "pointer"
    },
    breadCrumbLast: {
        textDecoration: "underline",
        cursor: "default"
    },
    breadcrumbsSeparator: {
        fontSize: 18
    },
    // Utility flex classes
    flexColumn: {
        display: "flex",
        flexDirection: "column"
    },
    flexRow: {
        display: "flex",
        flexDirection: "row"
    },
    button: {
        padding: "16px 32px",
        background: "#FFFFFF",
        borderRadius: 100,
        whiteSpace: "nowrap",
        fontWeight: 400,
        fontSize: 14,
        marginLeft: 20,
        "@media (max-width: 600px)": {
            marginLeft: 0,
            padding: "8px 16px"
        }
    },
    buttonEmailOverlay: {
        marginLeft: 0,
        marginBottom: 48
    }
}));
export default useBuyoutStyles;
//# sourceMappingURL=BuyoutStyles.js.map